import {
    Collapse,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Radio,
    RadioGroup,
    Stack,
} from '@chakra-ui/react';
import styled from '@emotion/styled';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { type CategoryBillingQuestion } from '../../../api/services/categories';
import { type HtmlFormInput } from '../../hooks/useHtmlFormInputs';

export type AdditionalQuestionsProps = {
    input: HtmlFormInput<string | null>;
    question?: CategoryBillingQuestion;
};

export const AdditionalQuestionsField = ({ input, question }: AdditionalQuestionsProps) => {
    const { control } = useFormContext();
    const { t } = useTranslation();

    const {
        field: { onChange: onChangeBillingAnswer, ...field },
        fieldState: { error },
    } = useController({
        name: 'billing_answer',
        control,
        rules: {
            required: question !== undefined ? t('common.errors.required') : undefined,
        },
    });

    return (
        <Collapse in={question !== undefined}>
            {question !== undefined && (
                <FormControl variant="fastDetails" my="8 !important" isInvalid={Boolean(error)}>
                    <FormLabel>{question.content}</FormLabel>
                    <RadioQuestionGroup
                        {...field}
                        onChange={(e) => {
                            input.onChange(e);
                            onChangeBillingAnswer(e);
                        }}
                    >
                        <Stack>
                            {question.answers.map((answerData) => (
                                <Radio value={String(answerData.id)} key={answerData.id}>
                                    {answerData.content}
                                </Radio>
                            ))}
                        </Stack>
                    </RadioQuestionGroup>
                    <FormErrorMessage>{error?.message}</FormErrorMessage>
                </FormControl>
            )}
        </Collapse>
    );
};

const RadioQuestionGroup = styled(RadioGroup)`
    label {
        margin-bottom: 0;
        color: var(--ck-colors-panel-550);
        font-size: var(--ck-fontSizes-md);
        line-height: 150%;
        letter-spacing: 0.16px;
    }
`;
